/* (c) Copyright Frontify Ltd., all rights reserved. */

import { createFondueIcon } from '../createFondueIcon';

/**
 * @component @name Minus
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTUgMTEuNzVhLjc1Ljc1IDAgMDEuNzUtLjc1aDEyLjVhLjc1Ljc1IDAgMDEwIDEuNUg1Ljc1YS43NS43NSAwIDAxLS43NS0uNzUiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==) - https://fondue-components.frontify.com/?path=/story/icons-icons--default&args=iconName:minus
 * @see https://fondue-components.frontify.com/?path=/story/icons-icons--default - Documentation
 */
export const IconMinus = createFondueIcon('Minus', [["path",{"fill":"currentColor","fill-rule":"evenodd","d":"M5 11.75a.75.75 0 01.75-.75h12.5a.75.75 0 010 1.5H5.75a.75.75 0 01-.75-.75","clip-rule":"evenodd"}]]);
